import React from 'react';
import AdminBookCard from './AdminBookCard';
import AdminBibleCard from './AdminBibleCard';
import AdminThingCard from './AdminThingCard';

const AdminProductCard = ({ book, onEdit, searchQuery = '', highlightSearchTerm = null }) => {
  // Determine product type from the data structure
  const getProductType = () => {
    if (book?.productType) {
      return book.productType;
    }
    
    // Fallback logic for legacy data or direct database queries
    if (book?.product_type) {
      return book.product_type;
    }
    
    // Default to book if no type specified
    return 'book';
  };

  const productType = getProductType();

  // Route to appropriate admin card component based on product type
  switch (productType) {
    case 'bible':
      return <AdminBibleCard product={book} onEdit={onEdit} searchQuery={searchQuery} highlightSearchTerm={highlightSearchTerm} />;
    case 'thing':
      return <AdminThingCard product={book} onEdit={onEdit} searchQuery={searchQuery} highlightSearchTerm={highlightSearchTerm} />;
    case 'book':
    default:
      return <AdminBookCard book={book} onEdit={onEdit} searchQuery={searchQuery} highlightSearchTerm={highlightSearchTerm} />;
  }
};

export default AdminProductCard;

